import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    transactionList: [
        {
            transactionNumber: '10',
            name: 'James Whitaker',
            type: 'Angel',
            amount: '$130 USD',
            plan: 'Monthly Plan',
            date: 'May 2, 2024',
            status: 'Success'
        },
        {
            transactionNumber: '9',
            name: 'Olivia Hastings',
            type: 'VC',
            amount: '$1,000 USD',
            plan: 'Yearly Plan',
            date: 'May 3, 2024',
            status: 'Failed'
        },
        {
            transactionNumber: '8',
            name: 'Brandon Cole',
            type: 'Accelerator',
            amount: '$100 USD',
            plan: 'Monthly Plan',
            date: 'April 29, 2024',
            status: 'Refund'
        },
        {
            transactionNumber: '520',
            name: 'Sophia Klein',
            type: 'Angel',
            amount: '$250 USD',
            plan: 'Yearly Plan',
            date: 'April 17, 2024',
            status: 'Success'
        },
        {
            transactionNumber: '6',
            name: 'Ethan Morales',
            type: 'VC',
            amount: '$130 USD',
            plan: 'Monthly Plan',
            date: 'May 16, 2024',
            status: 'Failed'
        },
        {
            transactionNumber: '5',
            name: 'Madison Lee',
            type: 'Accelerator',
            amount: '$1,000 USD',
            plan: 'Yearly Plan',
            date: 'September 1, 2024',
            status: 'Refund'
        },
        {
            transactionNumber: '4',
            name: 'Dylan Prescott',
            type: 'Angel',
            amount: '$2,000 USD',
            plan: 'Monthly Plan',
            date: 'April 17, 2024',
            status: 'Success'
        },
        {
            transactionNumber: '3',
            name: 'Isabella Novak',
            type: 'VC',
            amount: '$250 USD',
            plan: 'Yearly Plan',
            date: 'April 21, 2024',
            status: 'Failed'
        },
        {
            transactionNumber: '2',
            name: 'Marcus Bell',
            type: 'Accelerator',
            amount: '$130 USD',
            plan: 'Monthly Plan',
            date: 'April 29, 2024',
            status: 'Refund'
        },
        {
            transactionNumber: '1',
            name: 'Chloe Ramsey',
            type: 'Angel',
            amount: '$250 USD',
            plan: 'Yearly Plan',
            date: 'July 13, 2024',
            status: 'Success'
        },
    ],
    singleTransaction: {
        paymentNumber :'#231',
        date: 'April 12, 2024',
        paymentType: 'Success',
        name: 'James Whitaker',
        userType: 'VC',
        plan: 'Active',
        planName: 'Monthly Plan',
        amount: '$130',
        stripe: 'Link to Stripe'
    }
}

const transactionSlice = createSlice({
    name: 'transactions',
    initialState,
    reducers: {
        setTransaction: (state, action) => {
            state.transactionList = action.payload;
        },
        setSingleTransaction: (state, action) => {
            state.singleTransaction = action.payload;
        },
    },
});

export const {
    setTransaction,
    setSingleTransaction
} = transactionSlice.actions;

export default transactionSlice.reducer;